<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>License Number:</label>
	<input [disabled]="Processing == true" class="form-control" type="text" placeholder="" [(ngModel)]="LicenseNbr" />

	<label>Driver Name (Optional):</label>
	<input [disabled]="Processing == true" class="form-control" type="text" placeholder="" [(ngModel)]="DriverName" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
